import { UFS } from '@fiscoai/contracts';

import { SelectPesquisavel } from './select-pesquisavel';

const OPCOES = UFS.map((uf) => ({ valor: uf.sigla, rotulo: uf.nome, detalhe: uf.sigla }));

interface SeletorUfProps {
  valor: string | null | undefined;
  aoMudar: (sigla: string) => void;
  id?: string;
  'aria-label'?: string;
  'aria-invalid'?: true;
  'aria-describedby'?: string;
  className?: string;
  disabled?: boolean;
}

/** Estado pelo nome por extenso ("Bahia"), com busca ("bah"); o valor é a sigla ("BA"). */
export function SeletorUf({ valor, aoMudar, ...resto }: SeletorUfProps) {
  return (
    <SelectPesquisavel
      opcoes={OPCOES}
      valor={valor === '' ? null : (valor ?? null)}
      aoMudar={(sigla) => {
        if (sigla) aoMudar(sigla);
      }}
      rotuloBusca="Buscar estado"
      placeholder="Escolha o estado"
      vazio="Nenhum estado encontrado."
      {...resto}
    />
  );
}
